import WindowLocation from 'helpers/windowLocation'

const RESIDENTIAL_BUSINESS_UNIT = 'residential'
const COMMERCIAL_BUSINESS_UNIT = 'commercial'

const TRANE_HOME = 'trane_home'
const ASAIR_HOME = 'asair_home'
const TRANE = 'trane'

export type BrandName = typeof TRANE_HOME | typeof ASAIR_HOME | typeof TRANE

export const currentBrandName = (): BrandName => {
  if (WindowLocation.hostname().match(/tranehome[-.]/)) {
    return TRANE_HOME
  } else if (WindowLocation.hostname().match(/asairhome[-.]/)) {
    return ASAIR_HOME
  } else if (WindowLocation.hostname().match(/trane[-.]/)) {
    return TRANE
  } else if (WindowLocation.hostname().match(/tranetechdev/)) {
    return TRANE_HOME
  } else {
    return TRANE_HOME
  }
}

export const currentBusinessUnit = () => {
  return currentBrandName() === TRANE ? COMMERCIAL_BUSINESS_UNIT : RESIDENTIAL_BUSINESS_UNIT
}

export const isResidentialBrand = () => {
  return currentBusinessUnit() === RESIDENTIAL_BUSINESS_UNIT
}

export const isCommercialBrand = () => {
  return currentBusinessUnit() === COMMERCIAL_BUSINESS_UNIT
}
